import { AxiosResponse } from "axios";
import { AUDIT_CODE_ENDPOINTS } from "constants/apiEndPoints";
import ThrottledApi from "./api/throttledApi";

export type AuditCodeListItem = {
    store_location_id: string;
    store_location_name: string;
    store_location_type: string;
    active: boolean;
    code: string | null;
    created_at: string | null;
};

export type AuditCodeResponse = {
    id: string;
    store_location_id: string;
    code: string;
    created_at: string;
};

export const listAuditCodes = async (storeId: string): Promise<AuditCodeListItem[]> => {
    const response = await ThrottledApi.get(AUDIT_CODE_ENDPOINTS.LIST_AUDIT_CODES(storeId)) as AxiosResponse<AuditCodeListItem[]>;
    return response.data || [];
};

export const generateAuditCode = async (storeId: string, storeLocationId: string): Promise<AuditCodeResponse> => {
    const response = await ThrottledApi.post(AUDIT_CODE_ENDPOINTS.GENERATE_AUDIT_CODE(storeId, storeLocationId), {}) as AxiosResponse<AuditCodeResponse>;
    return response.data;
};

export const revokeAuditCode = async (storeId: string, storeLocationId: string): Promise<void> => {
    await ThrottledApi.delete(AUDIT_CODE_ENDPOINTS.REVOKE_AUDIT_CODE(storeId, storeLocationId));
};

const auditCodeService = {
    listAuditCodes,
    generateAuditCode,
    revokeAuditCode,
};

export default auditCodeService;
